
<app-navbar></app-navbar>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
